/**
 * One UserEvent -> one popup row.
 *
 * Two rules the reconciliation depends on:
 *  - rows are NEVER dropped. An event whose lead is missing (deleted, merged,
 *    out of scope) still renders, with the lead cell degraded. Dropping it
 *    would make the popup disagree with the column it was opened from.
 *  - the row id is the EVENT id, not the lead id. Two bookings for one lead are
 *    two rows, which is what makes the count reconcile.
 */
export const mapEventToRow = (event, index) => {
    const e = event || {};
    const leadId = e.lead ?? null;
    return {
        id: e.id ?? `evt-${index}`,
        index: index + 1,
        leadId,
        leadName: e.lead_name || (leadId ? `Lead ${leadId}` : 'Lead unavailable'),
        leadUnavailable: !leadId,
        treatment: e.lead_treatment?.treatment_name || e.lead_treatment?.treatment || '—',
        source: e.channel || '—',
        eventType: e.event_type || '—',
        eventTime: e.event_datetime || e.event_date || '—',
        description: e.description || '—',
    };
};

/**
 * Lead ids a bulk action should touch, given event rows.
 * Two bookings for one lead are two ROWS but one LEAD — acting per row would
 * hit the same lead twice. Rows with no lead cannot be acted on at all.
 */
export const distinctLeadIdsForAction = (rows = []) => [
    ...new Set(rows.filter((r) => r && r.leadId != null).map((r) => r.leadId)),
];
